export default __webpack_public_path__ + "static/media/16.c879f2b1.png";